/**
 * Public types for `<app-filter-chip>` — a toggleable chip used for filters
 * and segmented choice groups (e.g. "duration" pickers).
 *
 * Family: chips. Visually shares anatomy with `app-info-chip` (size/shape) but
 * adds a toggle state and a default `check_circle` leading icon when selected.
 */

export type FilterChipSize = 'small' | 'large';
export type FilterChipShape = 'rounded-small' | 'rounded-large';
export type FilterChipColor = 'gray' | 'blue';
export type FilterChipIconSet =
  | 'material-symbols-rounded'
  | 'material-icons'
  | 'material-icons-outlined';

/**
 * Default values exported as constants so consumers do not depend on
 * “magic strings” (R16 — Tipos exportables en `*.types.ts`).
 */
export const MUNILY_FILTER_CHIP_DEFAULTS = {
  size: 'large' as FilterChipSize,
  shape: 'rounded-small' as FilterChipShape,
  color: 'gray' as FilterChipColor,
  iconSet: 'material-symbols-rounded' as FilterChipIconSet,
  /** Leading icon shown when the chip is selected and no custom one is set. */
  selectedIcon: 'check_circle' as string,
};
